$(document).ready(function () {
  try {
    $('.order-lookup')
      .on('focusin', '#ola_orderLookUp_formWrapper input[type="text"]', function () {
        $(this).prev('label').hide();
      })
      .on('focusout', '#ola_orderLookUp_formWrapper input[type="text"]', function () {
        let $this = $(this);
        if ($this.val() === '') {
          $this.prev('label').show();
        }
      });
  } catch (e) {
    Rollbar.error('order lookup js', e);
  }
});
